import PlpRatingWidget from './PlpRatingWidget';

export default PlpRatingWidget;
